<template>
    <div class="kt-portlet kt-portlet--height-fluid kt-portlet--mobile container-fluid animated fadeIn">
        <div class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm linea2">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title text-primary">{{obj.dt4}} {{obj.ndt4}}<span class="text-muted">{{ obj.ddt1 | hummans}}</span></h3>
            </div>
            <div class="kt-portlet__head-toolbar" v-if="btn">
                <div class="dropdown dropdown-inline" v-if="false">
                    <button type="button" class="btn btn-clean btn-sm btn-icon btn-icon-md" >
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="kt-portlet__body kt-portlet__body--fit pt-2">
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <img :src="obj.dt7 ? uri + obj.dt7 : uri + obj.dt6" class="img-fluid">
                </div>
                <div class="col-lg-8 col-sm-12 d-flex justify-content-center justify-content-lg-end pr-lg-5">
                  <div>
                    <h5 class="text-capitalize">{{ obj.dt4 }}</h5>
                    <h6 class="text-capitalize text-muted">{{ obj.dt8 | minusculas }}</h6>
                    <table class="table table-responsive table-sm table-borderless">
                      <tbody>
                      <template v-for="(item,index) in lista">
                        <tr :key="index" class="bg-secondary" v-b-toggle="'collapse-'+obj.id+'-'+index">
                          <td>
                            <h6 class="p-2">{{ item.label }}</h6>
                          </td>
                          <td>
                            <h6 class="p-2 text-right precio-syb">{{ sumaItems(item) | puntos }}</h6>
                          </td>
                        </tr>
                        <b-collapse :id="'collapse-'+obj.id+'-'+index" :key="index+'col'" tag="tr" style="width: 100%;">
                          <td v-if="item.array" colspan="2" style="width: inherit" class="p-0 m-0">
                              <tr v-for="(subItem,subIndex) in obj[item.array]" :key="subIndex+'-'+index" style="width: inherit;display: table">
                                <td>
                                  <h6 class="p-2">{{ subItem[item.dtoDetail] }}</h6>
                                </td>
                                <td>
                                  <h6 class="p-2 text-right precio-syb">{{ subItem[item.dtoNumber] | puntos }}</h6>
                                </td>
                              </tr>
                          </td>
                          <template v-else>
                            <td>
                              <h6 class="p-2">{{ obj[item.dtoDetail] }}</h6>
                            </td>
                            <td>
                              <h6 class="p-2 text-right precio-syb">{{ obj[item.dtoNumber] | puntos }}</h6>
                            </td>
                          </template>
                        </b-collapse>
                      </template>
                      <tr class="bg-dark">
                        <td>
                          <h6 class="p-2 text-white label-table">
                            <b>Precio total del vehículo</b>
                          </h6>
                        </td>
                        <td>
                          <h6 class="p-2 text-white label-table text-right precio-syb">
                            <b>{{ obj.ndt3 | puntos }}</b>
                          </h6>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <div class="col-md-6 offset-md-6 d-flex justify-content-center pr-lg-2" v-if="btn && !obj.bdt1">
                <div class="p-3">
                    <button class="btn btn-brand btn-elevate btn-pill btn-elevate-air" v-on:click="irPrivacidad">
                        Comprar contado
                    </button>
                </div>
                <div class="p-3">
                    <button class="btn btn-brand btn-elevate btn-pill btn-elevate-air" v-on:click="irCredito">
                        Solicitar financiamiento
                    </button>
                </div>
            </div>
        </div>
        <b-modal id="modal-scrollable" ref="privacy" size="lg" hide-footer hide-header title="Kia" body-class="m-0 p-0" v-if="btn && !obj.bdt1">
            <modal-privacidad v-on:aceptado="irContado"></modal-privacidad>
        </b-modal>
    </div>
</template>

<script>
    import constantes from "../constantes";
    import modalPrivacidad from "../componentes/modal-privacidad"
    //import {negociacion} from "../servicios";
    export default {
        name: "resumen-personalizado",
        data:()=>({
            uri:process.env.VUE_APP_URL_API,
          lista:[
            {
              label: "Paquetes",
              array: null,
              dtoNumber: "ndt8",
              dtoDetail: "dt1",
            },
            {
              label: "Accesorios individuales",
              array: 'elements',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
            {
              label: "Kit de accesorios",
              array: 'elements2',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
            {
              label: "Mantenimientos prepagados",
              array: 'elements3',
              dtoNumber: "ndt1",
              dtoDetail: "dt1",
            },
          ]
        }),
      filters: {
        puntos:(numero)=>constantes.funciones.puntoMilesDecimal(numero),
        hummans:(fecha)=>constantes.funciones.formatoFechaH(fecha),
        minusculas:(texto)=>constantes.funciones.minusculas(texto),
      },
        methods:{
            puntos:(numero)=>constantes.funciones.puntoMilesDecimal(numero),
            suma:(vector)=>constantes.funciones.sumar(vector),
          suma3: (key, vector) => constantes.funciones.sumar3(key, vector),
          sumaItems:function(item){
              let suma = 0;
              if(item.array){
                suma+=this.suma3(item.dtoNumber,this.obj[item.array])
              }else{
                suma+=this.obj[item.dtoNumber];
              }
              return suma;
          },
            irPrivacidad:function(){
                this.$refs['privacy'].toggle();
            },
            irCredito:function(){
                this.obj.tipo=2;
                this.actualizar(2)
            },
            irContado:function(){
                this.obj.tipo=1;
                this.actualizar(1)
            },
            setCotizacion:function(){
                this.$store.commit('setCotizacion',this.obj);
            },
            actualizar:function(tipo){
                if(tipo===1)
                     this.$router.push({ name: 'compras.contado' });
                 if(tipo===2)
                     this.$router.push({ name: 'compras.credito' });
                 this.setCotizacion();
            }
        },
        components:{
            modalPrivacidad
        },
        props:{
            obj:{
                type:Object,
                required: true,
            },
            btn:{
                type: Boolean,
                required: false,
                default: true,
            }
        }
    }
</script>

<style scoped>
    h3>span{
        display: block;
        font-size: x-small;
    }
    td>h6{
      margin: 0;
    }
    .bg-secondary{
      cursor: pointer;
    }
    tr.bg-secondary td:first-child h6:before{
      content: " ";
      transition: all .3s ease;
      font-family: "Font Awesome 5 Free",serif;
      font-style: normal;
      font-weight: 900;
      font-variant: normal;
      line-height: 1;
      text-decoration: inherit;
      text-rendering: optimizeLegibility;
      text-transform: none;
    }
    tr.collapsed td:first-child h6:before{
      content: " ";
      transition: all .3s ease;
      font-family: "Font Awesome 5 Free",serif;
      font-style: normal;
      font-weight: 900;
      font-variant: normal;
      line-height: 1;
      text-decoration: inherit;
      text-rendering: optimizeLegibility;
      text-transform: none;
    }
</style>
